import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";

const UserProjectDropdown = (props) => {
  const {
    onChange,
    ProjectsOption,
    defaultValue,
    userId,
    setUserProjectDropdownData,
    disabledDropdown,
  } = props;

  const [projects, setProjects] = useState(ProjectsOption || []);

  const getUsersProjects = async () => {
    if (!ProjectsOption || ProjectsOption.length === 0) {
      try {
        const response = await apiGet(`/v1/projects/${userId}`, false);
        const projectOptions = response.data.map((project) => ({
          id: project.projectId,
          label: project.propertyName,
        }));
        setProjects(projectOptions);
        setUserProjectDropdownData(projectOptions);
      } catch (error) {
        console.error("Error fetching projects", error);
      }
    }
  };

  useEffect(() => {
    getUsersProjects();
  }, [ProjectsOption, userId]);

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      placeholder="Select property"
      options={projects}
      onChange={(value) => onChange(value)}
      borderColor="#ED850C"
      disabled={true}
      width={"200px"}
      height={"33px"}
      disabledDropdown={disabledDropdown}
    />
  );
};

export default UserProjectDropdown;
